import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Grid } from '@material-ui/core'
import { Email, Sms } from '@material-ui/icons'
import { withRouter } from 'react-router-dom'
import Button from 'components/theme/Button'
import { read } from 'actions/data'
import {
	selectConversation,
	changeTo,
	selectContact,
	toggleContactViewPanel,
	contactSearch,
} from 'actions/inbox'

export default withRouter(
	connect(
		(state) => ({
			email: state.addOrEditContact.fields.email?.[0]?.value,
			phone: state.addOrEditContact.fields.phones?.[0]?.value,
			phoneNumber: state.addOrEditContact.fields.phones?.[0]?.number, // this has the +1 next to it
			contactID: state.addOrEditContact.contactID,
			inboxKeys:
				typeof state.data.inbox === 'object' &&
				Object.keys(state.data.inbox).reduce((acc, el) => {
					acc[el] = true
					return acc
				}, {}),
			contact:
				state.contacts.contactsWithEmailsByID?.[
					state.addOrEditContact?.contactID
				],
		}),
		(dispatch) =>
			bindActionCreators(
				{
					selectConversation,
					changeTo,
					read,
					selectContact,
					toggleContactViewPanel,
					contactSearch,
				},
				dispatch,
			),
	)(
		class StartAConversation extends Component {
			render() {
				const {
					email,
					phone,
					phoneNumber,
					contactID,
					selectConversation,
					changeTo,
					history,
					inboxKeys,
					read,
					contact,
					selectContact,
					toggleContactViewPanel,
					contactSearch,
				} = this.props

				return (
					<div>
						<div style={{ margin: '5px 0 20px 2px', fontSize: 12 }}>
							Select what type of conversation you'd like to begin.
						</div>
						<Grid container spacing={24}>
							<Grid item>
								<Button
									disabled={contactID === 'new' || !email.length}
									color="secondary"
									variant="outlined"
									onClick={() => {
										if (inboxKeys[contactID]) {
											read(
												contactID,
												'inbox',
												'inbox/conversation',
												'contact_id',
											).then((payload) => {
												Promise.resolve(selectConversation(contactID))
													.then(() => changeTo('email', email, contactID))
													.then(() => history.push('/inbox'))
												// .then(() => receiveContact(payload.contact))
											})
										} else {
											Promise.resolve(selectContact(contact))
												.then(() => changeTo('email', email, contactID))
												.then(() => toggleContactViewPanel(false))
												.then(() => contactSearch(''))
												.then(() => history.push('/inbox'))
										}
									}}
								>
									<Email style={{ marginRight: 5 }} />
									Send an email
								</Button>
							</Grid>
							<Grid item>
								<Button
									disabled={contactID === 'new' || !phone.length}
									color="secondary"
									variant="outlined"
									onClick={() => {
										if (inboxKeys[contactID]) {
											read(
												contactID,
												'inbox',
												'inbox/conversation',
												'contact_id',
											).then((payload) => {
												Promise.resolve(selectConversation(contactID))
													.then(() => changeTo('text', phoneNumber, contactID))
													.then(() => history.push('/inbox'))
												// .then(() => receiveContact(payload.contact))
											})
										} else {
											Promise.resolve(selectContact(contact))
												.then(() => changeTo('text', phoneNumber, contactID))
												.then(() => toggleContactViewPanel(false))
												.then(() => contactSearch(''))
												.then(() => history.push('/inbox'))
										}
									}}
								>
									<Sms style={{ marginRight: 5 }} />
									Send a text message
								</Button>
							</Grid>
						</Grid>
					</div>
				)
			}
		},
	),
)
